import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Helmet } from 'react-helmet-async';
/**
 * Common Helmet page with basic SEO meta tags.
 * @param title main page title.
 * @param description optional page description.
 * @param name optional creator name.
 * @param type optional page type.
 * @param children optional other tags.
 * @returns head content.
 */ export const SEO = (param)=>{
    let { title, description = "".concat(title, " page"), name, type, children } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Helmet, {
                children: [
                    /*#__PURE__*/ _jsx("title", {
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        property: "og:type",
                        content: type
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        name: "twitter:creator",
                        content: name
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        name: "twitter:card",
                        content: type
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        name: "twitter:description",
                        content: description
                    })
                ]
            }),
            children
        ]
    });
};
